import React, { useState, useEffect } from "react";
import "./HelpSection.css";

export default function HelpSection() {
  

  return (
    <div className="help-section-container">
      <h2 className="help-section-title">Help Section</h2>

      
      <p style={{ color: "white" }}>Email: vrumies@gmail.com</p>
      
    </div>
  );
}